import { fireFunctions } from './firebase';

// fireFunctions.useFunctionsEmulator('http://localhost:5001');

export const saveCardTokenFunction = fireFunctions.httpsCallable('saveCardToken');
